import React, { useEffect, useState } from "react";
import { useIsMobile } from "../../../hooks/useIsMobile";
import {
    getBook,
    getLikeAuthorCardList,
    getLikeBookList,
    getLikePostCardList, getMypageBookList, getMypagePostCardList,
    getProfile
} from "../../../api/index";
import { BeatLoader } from "react-spinners";
import MypageLayout from "./MypageLayout";
import Loading from "../../controls/Loading";
import { useLoading } from "../../controls/LoadingContext";

const MypageContainer = () => {
    const isMobile = useIsMobile();
    const { showLoading, hideLoading } = useLoading();
    const [profileList, setProfileList] = useState<any>(null);
    const [bookData, setBookData] = useState<any>([]);
    const [postcardData, setPostcardData] = useState<any>([]);
    const [authorData, setAuthorData] = useState<any>([]);
    const [mypageBookData, setMypageBookData] = useState<any>([]);
    const [mypagePostCardData, setMypagePostCardData] = useState<any>([]);
    //const [loading, setLoading] = useState(true);
    const [bookPage, setBookPage] = useState(1);
    const [postcardPage, setPostcardPage] = useState(1);
    const [authorPage, setAuthorPage] = useState(1);
    const [likeBookPage, setLikeBookPage] = useState(1);
    const [likPostcardPage, setLikePostcardPage] = useState(1);
    const itemsPerPage = 8;

    const authorStatus: string | null = localStorage.getItem("authorStatus");

    useEffect(() => {
        const fetchAllData = async () => {
            try {
                showLoading();

                // 1. 프로필 먼저 조회
                const profile = await getProfile();
                setProfileList(profile);

                // 2. 공통 데이터 조회
                const commonPromises = [
                    getLikeBookList(likeBookPage, itemsPerPage),
                    getLikeAuthorCardList(authorPage, itemsPerPage),
                    getLikePostCardList(likPostcardPage, itemsPerPage),
                ];

                // 3. 작가일 경우 추가 데이터 조회
                let myBooksPromise = Promise.resolve({ content: [], totalPages: 0 });
                let myPostcardsPromise = Promise.resolve({ content: [], totalPages: 0 });

                if (profile && profile.type === 'author') {
                    myBooksPromise = getMypageBookList(bookPage, itemsPerPage);
                    myPostcardsPromise = getMypagePostCardList(postcardPage, itemsPerPage);
                }

                const [books, authors, postcards, myBooks, myPostcards] = await Promise.all([
                    ...commonPromises,
                    myBooksPromise,
                    myPostcardsPromise
                ]);

                setBookData(books);
                setAuthorData(authors);
                setPostcardData(postcards);
                setMypageBookData(myBooks);
                setMypagePostCardData(myPostcards);

            } catch (error) {
                console.error("데이터 불러오기 실패:", error);
            } finally {
                hideLoading();
            }
        };

        fetchAllData();

    }, [likeBookPage, authorPage, likPostcardPage, bookPage, postcardPage]);



    const handlePageChange = (type: 'book' | 'postcard' | 'author' | 'mypageBook' | 'mypagePostcard', page: number) => {
        switch (type) {
            case 'book':
                setBookPage(page);
                break;
            case 'postcard':
                setPostcardPage(page);
                break;
            case 'author':
                setAuthorPage(page);
                break;
            case 'mypageBook':
                setBookPage(page);
                break;
            case 'mypagePostcard':
                setPostcardPage(page);
                break;
            default:
                console.warn(`Unknown page change type: ${type}`);
        }
    };
    ;

    /*    if (loading) {
    
            return <Loading />;
    
        }*/

    const pageProps = {
        profileList,
        bookData,
        postcardData,
        authorData,
        mypageBookData,
        mypagePostCardData,
        bookPage,
        postcardPage,
        handlePageChange
    };

    return (
        <>
            <MypageLayout {...pageProps} />

        </>

    )
};

export default MypageContainer;
